import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { auth } from "_firebase";

import { useQuery } from "utils/hooks";
import { getPasswordChecks, isPasswordValid } from "utils/auth/password";

import Button from "components/Button";
import Input from "components/Input";
import PasswordRequirements from "features/Auth/PasswordRequirements";

import classes from "../style.module.scss";

import VoltaLogo from "assets/images/logo-color.svg";

const NewPassword = () => {
    const history = useHistory();

    const searchParams = useQuery();
    const oobCode = searchParams.get("oobCode");

    const [newPassword, setNewPassword] = useState({
        password: "",
        confirmPassword: "",
    });
    const [passwordCheck, setPasswordCheck] = useState(getPasswordChecks());

    const handleReset = async (e) => {
        e.preventDefault();

        if (newPassword.password !== newPassword.confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        auth.verifyPasswordResetCode(oobCode)
            .then((email) => {
                auth.confirmPasswordReset(oobCode, newPassword.password).then(() => {
                    history.push("/login?passwordResetSuccess=true");
                });
            })
            .catch((error) => {
                history.push("/login?passwordResetError=Reset code is invalid or has expired");
            });
    };

    const handlePasswordChange = (name, value) => {
        const updated = { ...newPassword, [name]: value };
        setNewPassword(updated);
        setPasswordCheck(getPasswordChecks(updated.password, updated.confirmPassword));
    };

    useEffect(() => {
        if (!oobCode) {
            history.push("/login?passwordResetError=No reset code provided");
        }
    }, [oobCode, history]);

    return (
        <div className={classes.authWrapper}>
            <div className={classes.formWrapper}>
                <div className={classes.top}>
                    <img src={VoltaLogo} alt="Volta Snap logo in colour" />
                    <h2>Password Reset</h2>
                </div>
                <form className={classes.form}>
                    <Input
                        name="password"
                        input={{
                            value: newPassword.password,
                            onChange: (value) => handlePasswordChange("password", value),
                        }}
                        className={classes.input}
                        type="password"
                        label="New Password"
                        placeholder="Enter Your New Password"
                    />
                    <Input
                        name="confirmPassword"
                        input={{
                            value: newPassword.confirmPassword,
                            onChange: (value) => handlePasswordChange("confirmPassword", value),
                        }}
                        className={classes.input}
                        type="password"
                        label="Confirm Password"
                        placeholder="Confirm Your New Password"
                    />

                    <PasswordRequirements passwordCheck={passwordCheck} />

                    <Button
                        type="submit"
                        className={classes.submit}
                        disabled={!isPasswordValid(passwordCheck)}
                        onClick={handleReset}
                    >
                        Reset Password
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default NewPassword;
